import {Component, OnDestroy, OnInit} from '@angular/core';
import {orderBy} from 'lodash';
import {Subscription} from 'rxjs';
import {Helper} from '../../shared/helpers/helper';
import {CompaniesService} from '../manage/companies/companies.service';
import {UserAuthService} from '../../shared/services/user-auth.service';
import {pagingDefaultSettings} from '../../shared/directives/sortable-table-header.directive';
import { ThemesSettingsService } from '../../shared/services/themes-settings.service';
import { ENUM_THEMES } from '../../shared/helpers/app.constants';

@Component({
  selector: 'app-inventory',
  templateUrl: './inventory.component.html',
  styleUrls: ['./inventory.component.scss']
})
export class InventoryComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  loading: boolean = false;
  hideButton: boolean = false;

  // Company
  companyId: number;
  companyList: any[] = [];
  selectedCompanyList: any[] = [];

  // FracSpread
  fracSpreadId: number;
  fracSpreadList: any[] = [];
  selectedFracSpreadList: any[] = [];

  pagingState = { ...pagingDefaultSettings };

  // Table
  compareValueHeader: any[] = [];
  compareValueBody: any[] = [];

  isDarkTheme: boolean;

  constructor(
    private companiesService: CompaniesService,
    private userAuthService: UserAuthService,
    private themesSettingsService: ThemesSettingsService
  ) {
    this.onCheckDarkThemes();
    this.loading = true;
    const user = this.userAuthService.getUserInfo();
    if (user && user.companyType === 'Carbo') {
      this.getCompanyList();
    } else {
      this.companyId = user.companyId;
      this.hideButton = true;
      this.getFracSpreadList(this.companyId);
      this.loadData(this.companyId);
    }
  }

  private onCheckDarkThemes(): void {
    const localData = this.themesSettingsService.getLocalStorage();
    if (localData && localData.themes === ENUM_THEMES.Dark) {
      this.isDarkTheme = true;
      if (document.body.classList.value.toString().indexOf('frac-dark-theme') === -1) document.body.classList.add('frac-dark-theme');
    } else {
      this.isDarkTheme = false;
      document.body.classList.remove('frac-dark-theme');
    }
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    Helper.unsubscribe(this.subscriptions);
  }

  get dataTable(): any[] {
    return this.compareValueBody.slice(
      (this.pagingState.page - 1) * this.pagingState.pageSize,
      (this.pagingState.page - 1) * this.pagingState.pageSize + this.pagingState.pageSize
    );
  }

  fracSpreadSelect(e: any) {
    if (this.fracSpreadId !== e.id) {
      this.fracSpreadId = e.id;
      if (!(e && e.id)) {
        this.selectedFracSpreadList = [];
      }
      this.loadData(this.companyId, e.id);
    }
  }

  companySelect(e: any) {
    if (this.companyId !== e.id) {
      this.companyId = e.id;
      // Reset fracSpread
      this.fracSpreadId = null;
      this.selectedFracSpreadList = [];
      this.getFracSpreadList(e.id);
      this.loadData(this.companyId);
    }
  }

  getFracSpreadList(companyId: number) {
    this.subscriptions.push(
      this.companiesService.getListFracspread(companyId)
        .subscribe(
          (res) => {
            this.fracSpreadList = res.result;
          }
        )
    );
  }

  getCompanyList() {
    this.subscriptions.push(
      this.companiesService.getListCompany()
        .subscribe(
          (res) => {
            if (res && res.result.items.length > 0) {
              this.companyList = res.result.items.filter(item => item.typeName !== 'Operator');
              this.companyList = orderBy(this.companyList, item => item.name);
              this.selectedCompanyList = [this.companyList[0]];
              this.companyId = this.companyList[0].id;
              this.getFracSpreadList(this.companyId);
              this.loadData(this.companyId);
            }
          } , (error) => {
            this.loading = false;
          }
        )
    );
  }

  loadData(companyId: number, fracSpreadId?: number) {
    this.loading = true;
    this.subscriptions.push(
      this.companiesService.getListInventory(companyId, fracSpreadId).subscribe(
        (res) => {
          if (res) {
            this.compareValueHeader = res.result.header;
            this.compareValueBody = res.result.body;
            this.pagingState.collectionSize = res.result.body.length;
          }
          this.loading = false;
        }, (error) => {
          this.loading = false;
        }
      ));
  }

}
